import { render, staticRenderFns } from "./self-service.vue?vue&type=template&id=11764e5b&scoped=true&"
import script from "./self-service.vue?vue&type=script&lang=js&"
export * from "./self-service.vue?vue&type=script&lang=js&"
import style0 from "./self-service.vue?vue&type=style&index=0&id=11764e5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11764e5b",
  null
  
)

export default component.exports